<template>

  <div class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="container">
      <article>
        <section class="section white-panel pr0 mb2p">
          <div class="mr16">
            <h2 class="text-center fs18 font-weight-bold">精算金額(税込)</h2>
            <p class="text-center fs32 line-height1 font-weight-bold mb28">{{ $filters.addComma(this.inspection.payment_price) }}<span class="ml4 fs20 va-middle">円</span></p>
          </div>

          <div class="mb20">
            <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line dl-toggle">
              <dt class="color-font2">法定費用</dt>
              <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.weight_tax + this.inspection.inspection_price.revenue_stamp_fee + this.inspection.inspection_price.cali_fee) }}円</dd>
              <dd class="child pl8">
                <dl class="dl dl-m dl-fs14 dt65-dd35">
                  <dt class="color-font2">重量税</dt>
                  <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.weight_tax) }}円</dd>
                  <dt class="color-font2">自賠責保険24ヶ月</dt>
                  <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.cali_fee) }}円</dd>
                  <dt class="color-font2">印紙代</dt>
                  <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.revenue_stamp_fee) }}円</dd>
                </dl>
              </dd>
            </dl>
            <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line dl-toggle">
              <dt class="color-font2">車検基本料+定額整備費用</dt>
              <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.base_price + this.inspection.inspection_price.oil_exchanged_fee) }}円</dd>
              <dd class="child pl8">
                <dl class="dl dl-m dl-fs14 dt65-dd35">
                  <dt class="color-font2">車検基本料＋定額整備費用</dt>
                  <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_price.base_price) }}円</dd>
                  <dt class="color-font2" v-if="this.inspection.inspection_price.oil_exchanged_fee !== 0">エンジンオイル{{ $filters.oilExchanged(this.inspection.inspection_price.oil_exchanged_fee) }}</dt>
                  <dd class="color-red2" v-if="this.inspection.inspection_price.oil_exchanged_fee !== 0">{{ $filters.addComma(this.inspection.inspection_price.oil_exchanged_fee) }}円</dd>
                </dl>
              </dd>
            </dl>
            <dl v-if="this.inspection.inspection_price.coupon_fee !== null"  class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
              <dt class="color-font2">クーポン</dt>
              <dd class="color-red2">{{ $filters.addComma(this.inspection.inspection_price.coupon_fee) }}円</dd>
            </dl>
            <div v-if="this.inspection.inspection_additional_expense.length > 0">
              <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
                <dt class="color-font2">追加の発生費用</dt>
                <dd class="color-font1">{{ $filters.addComma(additionPrice) }}円</dd>
              </dl>
            </div>
            <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
              <dt class="color-font2">（うち消費税</dt>
              <dd class="color-font1">{{ $filters.addComma($filters.roundDown(taxPrice)) }}円）</dd>
            </dl>
          </div>

          <p class="fs14"><a id="legalFee" v-on:click='modalOpen($event)' class="color-green2">法定費用について</a></p>
          <p class="fs14"><a id="basicFee" v-on:click='modalOpen($event)' class="color-green2">車検基本料+定額整備費用について</a></p>
        </section>

        <section v-if="this.inspection.inspection_additional_expense.length > 0" class="section white-panel mb2p">
          <h2 class="text-center fs18 font-weight-bold mb16">追加の発生費用</h2>
            <dl class="dl dl-l dl-fs16 dt65-dd35 mb20">
              <template v-for="item in this.inspection.inspection_additional_expense">
                <dt class="color-font2">{{ item.contents }}</dt>
                <dd class="color-font1 mb4">{{ $filters.addComma(item.price) }}円</dd>
              </template>
            </dl>
        </section>

        <section class="section white-panel">
          <h2 class="text-center fs18 font-weight-bold mb16">お見積りのクルマ情報</h2>
          <dl class="dl dl-l dl-fs16 dt50-dd50 mb8">
            <dt class="color-font2">車検満了日</dt>
            <dd class="color-font1">{{ expiryOnWareki.gengo }}{{ $filters.checkFirstYear(expiryOnWareki.year) }}年{{ expiryOnWareki.month }}月{{ expiryOnWareki.date }}日</dd>
            <dt class="color-font2">初度登録年月</dt>
            <dd class="color-font1">{{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月</dd>
            <dt class="color-font2">自動車の種別</dt>
            <dd class="color-font1">{{ carType.name }}</dd>
            <dt class="color-font2">車名(メーカー)</dt>
            <dd class="color-font1">{{ Manufacturer.manufacturer_name }}</dd>
            <dt class="color-font2">車両重量</dt>
            <dd class="color-font1">{{ $filters.addComma(this.inspection.inspection_estimate.weight) }}kg</dd>
            <dt class="color-font2">走行距離</dt>
            <dd class="color-font1">{{ this.mileageWordSet(this.inspection.inspection_estimate.mileage)}}</dd>
          </dl>
        </section>

        <div class="section transparent-panel">
          <button v-on:click='moveTop()' class="button fs16 mt12 mb16 pd16 radius200">コミっと車検トップに戻る</button>
        </div>

      </article>
    </div>
    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd24 mt8p mb8p">
          <div v-if="aboutLegal">
            <h2 class="fs18 mb8">法定費用について</h2>
            <p class="fs14 mb16">法律に基づき必ず発生する費用になります。<br>
              ・自賠責保険料：法律で車検更新時に必ず加入することが義務付けられている強制保険です。※お客様が任意で加入する任意保険とは別です。<br>
              ・重量税：自動車の重量に応じて納める税金です。エコカー減税により減額される場合もございます。詳細は店頭にてお伝えいたします。<br>
            ・印紙代：車検適合証発行の為に国に支払う費用です。</p>
          </div>
          <div v-if="aboutBasic">
            <h2 class="fs18 mb8">車検基本料＋定額整備費用</h2>
            <p class="fs14 mb16">法定24ヶ月点検の検査費用と、検査後に整備が必要となった30種類以上の定額整備対象部品の部品代金・工賃を含む費用になります</p>
          </div>
          <div v-if="aboutExchange">
            <h2 class="fs18 mb8">交換時期の目安</h2>
            <p class="fs14 mb16">タイヤについては、走行距離3万km、残溝1.6mm以下を目安に交換をおすすめしております。店頭での検査の上、交換を希望する場合はお好きな商品を別途お買い求めください。<br>
            タイミングベルトについては、走行距離10万km、10年以上を目安に交換をおすすめしております。</p>
          </div>
          <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
        </div>
        <!-- /.modal_body -->
      </div>
      <!-- /.modal_container -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inspectionApi from '@/store/Api/inspection'
import carTypeApi from '@/store/Api/cartype'
import manufacturersApi from '@/store/Api/manufacturers'
import Loading from '@/views/v2/Loading.vue'
import modal from '@/assets/v2/modal'

export default {
  computed: {
    ...mapGetters('INSPECTION_SETTLEMENT_COMPLETE', [
      'inspection'
    ]),
    additionPrice: function () {
      let price = 0
      const count = this.inspection.inspection_additional_expense.length
      for (let i = 0; i < count; i++) {
        price += Number(this.inspection.inspection_additional_expense[i].price)
      }
      return price
    },
    taxPrice: function () {
      // 車検基本料＋定額整備費用＋クーポン料金
      let price = (this.inspection.inspection_price.base_price + this.inspection.inspection_price.oil_exchanged_fee + this.inspection.inspection_price.coupon_fee)
      // 追加発生費用
      price = price + this.additionPrice
      // 消費税率を掛ける
      price = Math.round(price * Number(this.inspection.inspection_estimate.tax) * 10)
      price = price / 10
      // 1 + 消費税率を割る
      price = Math.round(price / (1 + Number(this.inspection.inspection_estimate.tax)) * 10)
      price = price / 10
      return price
    }
  },
  data () {
    return {
      tsid: '',
      otoken: '',
      popinfoid: '',
      inspectionid: '',
      modalActive: false,
      aboutLegal: false,
      aboutBasic: false,
      aboutExchange: false,
      expiryOnWareki: {},
      firstRegistrationOnWareki: {},
      carType: {},
      Manufacturer: {},
      loading: true
    }
  },
  methods: {
    ...mapActions('INSPECTION_SETTLEMENT_COMPLETE', [
      'setInspection'
    ]),
    modalOpen (about) {
      if (about.target.id === 'legalFee') {
        this.nativeEVENTSet('ShakenKessaiKanryouButton', 'MOVED_HOUTEI', 'TAP')
        this.aboutLegal = true
      } else if (about.target.id === 'basicFee') {
        this.nativeEVENTSet('ShakenKessaiKanryouButton', 'MOVED_KIHONRYOU', 'TAP')
        this.aboutBasic = true
      } else if (about.target.id === 'exchangeSeason') {
        this.nativeEVENTSet('ShakenKessaiKanryouButton', 'MOVED_MEYASU', 'TAP')
        this.aboutExchange = true
      }
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    modalClose () {
      this.aboutLegal = false
      this.aboutBasic = false
      this.aboutExchange = false
      this.modalActive = false
    },
    moveTop () {
      this.nativeEVENTSet('ShakenKessaiKanryouButton', 'MOVED_CARCARE', 'TAP')
      this.$router.push({
        name: 'InspectionTopV2',
        query: {
          tsid: this.tsid,
          otoken: this.otoken,
          popinfoid: this.popinfoid,
          x_cls_app_version: this.$route.query.x_cls_app_version,
          x_cls_os: this.$route.query.x_cls_os,
          x_cls_os_version: this.$route.query.x_cls_os_version
        }
      })
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    let isApiError = false
    this.tsid = this.$route.query.tsid
    this.otoken = this.$route.query.otoken
    this.popinfoid = this.$route.query.popinfoid
    this.inspectionid = this.$route.query.inspectionid

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.$route.query.x_cls_app_version = this.$route.query.x_cls_app_version ? this.$route.query.x_cls_app_version : '0.0.0'
      this.$route.query.x_cls_os = this.$route.query.x_cls_os ? this.$route.query.x_cls_os : 'iRidge'
      this.$route.query.x_cls_os_version = this.$route.query.x_cls_os_version ? this.$route.query.x_cls_os_version : '0.0'
    }

    $('.dl-toggle > .child').hide()
    $('.dl-toggle').click(
      function (l) {
        $(this).toggleClass('open')
        $('.child', this).slideToggle(500)
      })
    this.setInspection((await inspectionApi.getDetail(this.inspectionid)).data[0])
    // APIから自動車の種別、車名（メーカー）を取得する。
    await carTypeApi.getDetail(this.inspection.inspection_estimate.model_code).then(res => {
      this.carType = res.data.car_type
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturersApi.getDetail(this.inspection.inspection_estimate.manufacturer_id).then(res => {
      this.Manufacturer = res.data.manufacturer
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 車検満了日、初度登録年月の和暦を取得する。
    this.expiryOnWareki = this.toWareki(this.inspection.inspection_estimate.expiry_on)
    this.firstRegistrationOnWareki = this.toWareki(this.inspection.inspection_estimate.first_registration_on)

    this.nativePVset('SHAKEN_Kessai_Kanryou')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}
</script>

<style></style>
